// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tn on","whiteTheme":"to","markdownWrapper":"tp"};